export interface Rol {
  rolId: number;
  nombreRol: string;
  descripcion: string | null;
  activo: boolean;
}

export interface CreateRolDto {
  nombreRol: string;
  descripcion: string | null;
  activo: boolean;
}

export interface UpdateRolDto {
  nombreRol: string;
  descripcion: string | null;
  activo: boolean;
}

class RolesService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7123/api';
  }

  private getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    const token = localStorage.getItem('authToken');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }

  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;

    const response = await fetch(url, {
      ...options,
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        message: 'Error en la conexión con el servidor',
      }));
      throw new Error(errorData.message || `Error HTTP: ${response.status}`);
    }

    if (response.status === 204) {
      return {} as T;
    }

    return response.json();
  }

  async getAll(): Promise<Rol[]> {
    return this.request<Rol[]>('/roles');
  }

  async getById(id: number): Promise<Rol> {
    return this.request<Rol>(`/roles/${id}`);
  }

  async create(data: CreateRolDto): Promise<Rol> {
    return this.request<Rol>('/roles', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async update(id: number, data: UpdateRolDto): Promise<Rol> {
    return this.request<Rol>(`/roles/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  async delete(id: number): Promise<void> {
    await this.request<void>(`/roles/${id}`, {
      method: 'DELETE',
    });
  }
}

export const rolesService = new RolesService();
